export const titleize = (value?: string | null) => {
  if (value) {
    return value
      .split(/_| |-/)
      .map((x) => (x[0] ? x[0].toUpperCase() + x.slice(1) : ''))
      .join(' ');
  } else {
    return '';
  }
};

export const pluralize = (value: string, count?: number) => {
  if (count == 1) {
    return `${count} ${value}`;
  } else {
    return `${count} ${value}s`;
  }
};

export const capitalizeFirstLetter = (str?: string | null): string => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const camelize = (str: string): string => {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '')
    .replace(/_+(.)/g, function (match, letter) {
      return letter.toUpperCase();
    });
};

export function formatHtml(html?: string): string {
  if (!html) return '';

  // Simple HTML formatter - adds proper indentation for tags
  let formatted = '';
  let indent = 0;

  // Convert to string with normalized line breaks
  // Ensure both opening and closing tags start on new lines
  let str = html.toString().trim();

  // Replace > < with >\n< to put each tag on its own line
  str = str.replace(/>\s*</g, '>\n<');

  // Also ensure self-closing tags with content like <br /> are properly formatted
  str = str.replace(/(<[^>/]+)\/>/g, '$1 />');

  // Put Liquid control flow statements on their own lines if they aren't already
  str = str.replace(/({%\s*[^%]+%})/g, '\n$1\n').replace(/\n+/g, '\n');

  // Ensure <br> tags are on their own line
  str = str.replace(/(<br\s*\/?>)/gi, '\n$1\n');

  // Remove excessive newlines
  str = str.replace(/\n{3,}/g, '\n\n');

  // Process each line
  const lines = str.split('\n');
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const trimmedLine = line.trim();
    if (!trimmedLine) continue; // Skip empty lines

    // Check if this line is a closing HTML tag
    if (line.match(/^<\/\w/)) {
      indent -= 2; // Decrease indent before a closing tag
    }
    // Check if this is a Liquid closing tag (endif, endfor, etc.)
    else if (trimmedLine.match(/{%\s*end[a-z]+\s*%}/i)) {
      indent -= 2; // Decrease indent for Liquid closing tags
    }

    // Add the line with proper indentation
    formatted += ' '.repeat(Math.max(0, indent)) + trimmedLine + '\n';

    // Increase indent for opening HTML tags that aren't self-closing or DOCTYPE
    if (
      trimmedLine.match(/^<\w[^>]*[^/]>$/) &&
      !trimmedLine.match(/^<(img|br|hr|input|link|meta|source|!DOCTYPE)/i)
    ) {
      indent += 2;
    }
    // Increase indent for Liquid opening tags (if, for, unless, etc.) but not end tags
    else if (
      trimmedLine.match(/{%\s*[a-z]+(?!end)[^%]*%}/i) &&
      !trimmedLine.match(/{%\s*(?:elsif|else|when)[^%]*%}/i)
    ) {
      indent += 2;
    }
  }

  return formatted;
}

export const obfuscate = (value: string, limit = 0) => {
  if (!value) {
    return '';
  }

  const stringValue = String(value);
  const visiblePart = stringValue.substring(0, limit);
  const asterisks = '*'.repeat(10);

  return `${visiblePart}${asterisks}`;
};

export const truncate = (value: string, limit: number) => {
  if (value.length > limit) {
    return value.slice(0, limit) + '…';
  }
  return value;
};

export const getCopiedTitle = (title: string): string => {
  const copyRegex = /(Copy)\s*(\d*)$/i;
  const match = title.match(copyRegex);

  if (match && match[1] === 'Copy') {
    const copyNum = parseInt(match[2], 10) || 1;
    return title.replace(copyRegex, `Copy ${copyNum + 1}`);
  }

  return `${title} Copy`;
};
